import { Grid, Box } from "@mui/material";
import '../CommunityNewsPage.css'
import InfiniteScrollPrompt from "../InfiniteScrollPrompt.js";
import SmallArticleList from "../ArticleComponents/SmallArticleList.js";

export default function NonFeaturedArticles(props = {}) {

  const {
    editable,
    published,
    totalArticlesAvailable,
    moreAvailable,
    articles,
    loadArticles,
    loading,
    loadingMore,
  } = props

  return (<>
    <Box >
      <Grid container gap={0} sx={{ position: 'relative' }}>
        <Grid item xs={12}>
          <SmallArticleList
            articles={articles}
            loading={loading}
            editable={editable && !loading}
            published={published}
            news
          />
        </Grid>
      </Grid>
    </Box>
    {((totalArticlesAvailable !== undefined && articles?.length < totalArticlesAvailable) || moreAvailable) && <InfiniteScrollPrompt loading={loadingMore} 
      onClick={() => loadArticles(true)}
    />}
  </>);
}
